import { useEffect, useState } from "react"
import API from "../../../API";
import toast from "react-hot-toast";

export function useConstructor() {
  const api = new API()
  const [allTags,setAllTags] = useState({});
  const [name, setName] = useState('')
  const [type, setType] = useState('')
  const [answers, setAnswers] = useState([])
  const [typeForEighth, setTypeForEighth] = useState(1)
  const [tags, setTags] = useState([])
  const [textAnswers,setTextAnswers] = useState('')
  const [percent,setPercent]=useState(50)
  const [parameter,setParameter] = useState(null)

  function changeParameterType2(value){
    setParameter(value)
  }
  function changeName(nameQuestion) {
    setName(nameQuestion)
  }

  function changeType(typeId) {
    setType(typeId)
      setAnswers([])
      setName('')
      setTags([])
  }
  function changeTextAnswers(value) {
    setTextAnswers(value)
  }
  function changePercent(value){
    setPercent(value)
  }
  function changeTypeForEighth(typeId) {
    setTypeForEighth(typeId)
  }

  function changeTags(tags) {
    const tagsId = tags.map(tag => {
      return tag.id
    })
    setTags(tagsId)
  }

  // useEffect(() => {
  //   setAnswers([])
  //   setName('')
  //   setTags([])
  // }, [type])

  function changeAnswers(answer, id) {
    if (type !== '6' && type !== '9' && type !== '10') {
      setAnswers(prev => {
        prev[id] = answer
        return prev
      })
    } else {
      setAnswers(answer)
    }
  }

  function deleteAnswers(id) {
    setAnswers(prev => {
      prev[id] = null
      return prev
    })
  }

  function validation(data) {
    if (!data) {
      toast.error('Ошибка!')
      console.log('error')
      return false
    }
    if(data.description.length===0){
      toast.error('Введите текст вопроса!')
      console.log('text name error')
      return false
    }
    if(data.answers.length===0 && data.typeId!==3){
      toast.error('Создайте ответы!')
      console.log('answer error')
      return false
    }
    if (data.typeId.length === 0) {
      toast.error('Выберите тип задания!')
      console.log('type error')
      return false
    }
    if(data.typeId===1){
      let isMaxError = false;
      let isError = true;
      data.answers.forEach(item => {
        if (Number(item.percent) === 100) {
          isError=false
        }
        if(Number(item.percent) > 100){
          isMaxError=true
        }
      })
      if(isMaxError){
        console.log('max percent Error')
        toast.error('Максимальный процент за задание 100%!')
        return false
      }
      if(isError){
        console.log('percent Error')
        toast.error('Должен содержаться хотябы один полностью правильный ответ с 100%!')
        return false
      }
    }
    if (data.typeId === 2) {
      let sumPercent = 0;
      data.answers.forEach(item => {
        if (item.percent > 0) {
          sumPercent += Number(item.percent)
        }
      })
      if (sumPercent !== 100) {
        console.log('percent Error')
        toast.error('Сумма положительных процентов должна ровняться 100%!')
        return false
      }
    }
    if(data.typeId === 10) {
      let sumPercent = 0;
      let nameError = false;
      let valueError = false;
      data.answers.forEach((item,i) => {
        if (item[0].percent > 0) {
          sumPercent += Number(item[0].percent)
        }
        if(!item.includes(true) && i!==0){ //первая строка в таблице заголовки
          valueError=true
        }
        item.forEach((rowValue,j)=>{
          if(i+j!==0) { //проверяем, что не первая ячейка
            if((i===0 || j===0) && rowValue.text.length === 0){
              nameError=true
            }
          }
        })
      })
      if (sumPercent > 100) {
        console.log('percent Error')
        toast.error('Сумма положительных процентов не может привышать 100%!')
        return false
      }
      if(valueError){
        console.log('value Error')
        toast.error('Заполните все ответы!')
        return false
      }
      if(nameError){
        console.log('name Error')
        toast.error('Заполните название всех строк и столбцов!')
        return false
      }
    }
    if (data.typeId === 11) {
        const answersValue = [...data.answers];
        const props = answersValue.pop();
        if(props.percent>=100||props.percent<=0){
          console.log('percent Error')
          toast.error('Не верная разбалловка процентов!')
          return false
        }
        if(props.text.length===0){
          console.log('answer Error')
          toast.error('Введите ответ в поле для ответа!')
          return false
        }
        const typeQuestion = props?.type
        if(!typeQuestion){
          console.log('type Error')
          toast.error('Выберите количесвто ответов (один/много)!')
          return false
        }
        if(typeQuestion===1){
          let isMaxError = false;
          let isError = true;
          answersValue.forEach(item => {
            if (Number(item.percent) === 100) {
              isError=false
            }
            if(Number(item.percent) > 100){
              isMaxError=true
            }
          })
          if(isMaxError){
            console.log('max percent Error')
            toast.error('Максимальный процент за задание 100%!')
            return false
          }
        if(isError){
          console.log('percent Error')
          toast.error('Должен содержаться хотябы один полностью правильный ответ с 100%!')
          return false
        }
        }
        else if(typeQuestion===2){
          let sumPercent = 0;
          answersValue.forEach(item => {
            if (Number(item.percent) > 0) {
              sumPercent += Number(item.percent)
            }
          })
          if (sumPercent !== 100) {
            console.log('percent Error')
            toast.error('Сумма положительных процентов должна ровняться 100%!')
            return false
          }
        }
    }
  if(data.typeId===3 ||data.typeId===8){
    let isCheckTag = false
    if(data.tags.length===0) {
      console.log('Tags error')
      toast.error('Выберите тег "Предметная область"!')
      return false
    }
    allTags['Предметная область'].forEach(item=>{
      if(data.tags.includes(item.id)){
        isCheckTag=true;
      }
    })
    if(!isCheckTag){
        console.log('Tags error')
        toast.error('Выберите тег "Предметная область"!')
        return false
    }
  }
    return true
  }

  function createObject() {
    let arrAnswer;
    if(type === '2'){
      arrAnswer=answers.map(item=>{
        if(item){
          return{...item,parameter:parameter}
        }
        else return null
      })
    }
    else if (type === '8') {
      arrAnswer = answers.map(item => {
        if (item)
          return {type: typeForEighth, text: item}
        else return null
      })
    } else {
      arrAnswer = answers
    }
    if(type==='11'){ //добавляем доп параметры
      if(!!arrAnswer[arrAnswer.length-1]?.text){ // проверяем есть ли эти параметры там уже
        arrAnswer.pop()
      }
      arrAnswer.push({text:textAnswers, percent:percent,type:typeForEighth})
    }
    const data = {
      description: name,
      typeId: Number(type),
      answers: arrAnswer.filter(item => item !== null),
      tags: tags,
    }
    console.log(data)
    return data
  }

  function sendQuestion() {
    const data = createObject();

    if (validation(data)) {
      api.addQuestion(data).then().catch()
    }

    // here will be validation ?? by type question
  }

  function editQuestion(id) {
    const data = createObject();
    if (validation(data)) {
      api.editQuestion(id, data).then().catch()
    }

    // here will be validation ?? by type question
  }

  return {
    changeName,
    sendQuestion,
    changeType,
    changeAnswers,
    changeTags,
    deleteAnswers,
    editQuestion,
    changeTypeForEighth,
    changeTextAnswers,
    changePercent,
    changeParameterType2,
    setType,
    setAnswers,
    type,
    setAllTags
  }
}